import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  button: {
    padding: 0,
    fontWeight: 'normal',
    color: colors.blue,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textTransform: 'none',
    '&:disabled': {
      opacity: 0.6,
      userSelect: 'none',
      cursor: 'default',
    },
    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:active': {
      opacity: 0.6,
    },
  },
  regularText: {
    color: colors.text,
    '&:hover': {
      color: colors.blue,
      backgroundColor: 'transparent',
    },
  },
  startIcon: {
    marginLeft: 0,
  },
}));

const TextButton = ({ children, className, onClick, startIcon, endIcon, textView, disabled, classes }) => {
  const styleClasses = useStyles();
  return (
    <Button
      className={classnames(styleClasses.button, className, { [styleClasses.regularText]: startIcon || textView })}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      classes={{ ...classes, startIcon: styleClasses.startIcon }}
    >
      {children}
    </Button>
  );
};

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  startIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.number]),
  endIcon: PropTypes.element,
  textView: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
};

TextButton.defaultProps = {
  className: '',
  startIcon: null,
  endIcon: null,
  textView: false,
  disabled: false,
  onClick: () => {},
  classes: {},
};

export default TextButton;
